/**
 * Status einer Veranstaltungsvorlage
 */
export enum EventTemplateStatus {
   /**
    * Vorlage der Veranstaltung ist noch ein Entwurf.
    */
   draft = "draft",

   /**
    * Vorlage der Veranstaltung hat den Status „freigegeben“.
    */
   approved = "approved",
}

export const EventTemplateStatusNames = {
  draft: "Entwurf",
  approved: "Freigegeben",
};